import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const sendNotifications = async (payload) => {
  try {
    return await InternalApi.post(
      { server: "api/v1/", path: "admin/queue-notification" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
